import { TServerErrorResponse } from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";

export const USER_EMAIL_SIGNATURE_IMAGE_KEY = "user-email-signature-image";

/**
 * Browser-loadable URL for a signature image's bytes. Points at the proxy
 * (`/api/proxy` — same base as `http`), which authenticates via the session
 * cookie the browser sends automatically, so it works as an `<img src>`.
 */
export const signatureImageContentUrl = (id: string): string =>
  `/api/proxy${links.userEmailSignatureImage.content(id)}`;

export interface SignatureImageResponse {
  id: string;
  contentType: string;
  fileName: string | null;
}

export const listSignatureImages = async (): Promise<
  SignatureImageResponse[]
> => {
  try {
    const response = await http.get<SignatureImageResponse[]>(
      links.userEmailSignatureImage.index,
    );
    return response.data || [];
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

/**
 * Upload a signature image in a single multipart request. The server validates
 * the file, writes it to blob storage, and returns the stored image. Its bytes
 * load via `signatureImageContentUrl(id)` (the authenticated content endpoint).
 */
export const uploadSignatureImage = async (
  file: File,
): Promise<SignatureImageResponse> => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const response = await http.post<SignatureImageResponse>(
      links.userEmailSignatureImage.index,
      formData,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const deleteSignatureImage = async (id: string): Promise<void> => {
  try {
    await http.delete(links.userEmailSignatureImage.byId(id));
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
